module.exports = __webpack_public_path__ + "img/b_intro_2_en.61e8f60.png";